import * as React from 'react';
import clsx from 'clsx';
import { Link } from "react-router-dom"
import customStyles from "../../../assets/styles/customStyles";
import { Row, Col, Dropdown, Image, Menu } from "antd";
import { younoteAdminMenus } from "../../../config/constant";
import { checkPermission } from '../../../helpers/utilities';
import DropDownIcon from "../../../assets/images/icon_menus/Drop Down.svg";

const Menus = (props) => {
    const classes = customStyles(); const { menuHeight } = props;
    return (
        <div className={clsx(classes.primaryPaper, classes.primaryMenu)} style={{ height: 'calc(100% - ' + menuHeight + 'px)', overflow: "auto" }}>
            <div style={{ height: '100%', overflow: "hidden" }}>
                <Row gutter={16}>
                    <Col>
                        <h5 type="secondary" className={classes.subMenuLinkTitle}>{younoteAdminMenus.sub[0].menu}</h5>
                        <div className={clsx(classes.subMenuLinks)}>
                            <div>
                                {younoteAdminMenus.sub[0].sub.map((menus, i) => {
                                    return (
                                        checkPermission(menus.menu, 'Younote Admin') && <div key={i} className={clsx(classes.margin10t, 'menuCheck')}>
                                            <Link to={menus.link} className={clsx(classes.color, classes.bold)}>{menus.menu}</Link>
                                        </div>
                                    )
                                })
                                }
                            </div>
                        </div>
                    </Col>
                    <Col>
                        <h5 type="secondary" className={classes.subMenuLinkTitle}>{younoteAdminMenus.sub[1].menu}</h5>
                        <div className={clsx(classes.subMenuLinks)}>
                            <div>
                                {younoteAdminMenus.sub[1].sub.map((menus, i) => {
                                    return (
                                        checkPermission(menus.menu, 'Younote Admin') && <div key={i} className={clsx(classes.margin10t, 'menuCheck')}>
                                            <Link to={menus.link} className={clsx(classes.color, classes.bold)}>{menus.menu}</Link>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </Col>
                    <Col>
                        <h5 type="secondary" className={classes.subMenuLinkTitle}>{younoteAdminMenus.sub[2].menu}</h5>
                        <div className={clsx(classes.subMenuLinks)}>
                            <div>
                                <div className={classes.colCount}>
                                    {younoteAdminMenus.sub[2].sub.map((menus, i) => {
                                        return (
                                            menus.menu === 'Address' || menus.menu === 'Units' ?
                                                <Dropdown
                                                    key={i}
                                                    className={classes.padding10t}
                                                    overlay={
                                                        <Menu className={clsx(classes.addressDropdown)}>
                                                            {menus.sub.map(submenu => {
                                                                return (
                                                                    checkPermission(submenu.menu, 'Younote Admin') && <Menu.Item className={clsx(classes.color, classes.bold, 'menuCheck')} key={submenu.menu}>
                                                                        <Link to={submenu.link} className={clsx(classes.color, classes.bold)}>{submenu.menu}
                                                                        </Link>
                                                                    </Menu.Item>
                                                                )
                                                            })}
                                                        </Menu>
                                                    }>
                                                    <div>
                                                        <Link to={menus.link} className={clsx(classes.color, classes.bold, classes.PaddingRight10)}>{menus.menu}
                                                        </Link>
                                                        <Image
                                                            src={DropDownIcon}
                                                            preview={false}
                                                        />
                                                    </div>
                                                </Dropdown> : <>
                                                    {checkPermission(menus.menu, 'Younote Admin') && <div key={i} className={classes.padding10t}><Link to={menus.link} className={clsx(classes.color, classes.bold, 'menuCheck')}>{menus.menu}</Link></div>}
                                                </>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col>
                        <h5 type="secondary" className={classes.subMenuLinkTitle}>{younoteAdminMenus.sub[3].menu}</h5>
                        <div className={clsx(classes.subMenuLinks)}>
                            <div>
                                {younoteAdminMenus.sub[3].sub.map((menus, i) => {
                                    return (
                                        checkPermission(menus.menu, 'Younote Admin') && <div key={i} className={clsx(classes.margin10t, 'menuCheck')}>
                                            <Link to={menus.link} className={clsx(classes.color, classes.bold)}>{menus.menu}</Link>
                                        </div>
                                    )
                                })
                                }
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default Menus